import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { DialogActions, Link, Caption2, CardHeader, Card, Text as Text$, Caption1, DialogContent, Subtitle1, DialogTitle, DialogBody, DialogSurface, tokens, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { OpenRegular, TimerRegular, CheckmarkCircleFilled, WarningFilled } from "@fluentui/react-icons";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { take, length, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { tryFind, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { toShortDateString, utcNow, addYears, compare } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export function View(viewInputProps) {
    let elems_7, el_4, children, el_2, el, el_40, elems_6, el_38, elems_5, el_8, el_6, el_32, elems_3, text_1, el_10, el_12, elems_2, el_36, elems_4, el_34, elemsToUse;
    const completedTasks = viewInputProps.completedTasks;
    const trackOverview = viewInputProps.trackOverview;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const el_42 = Dialog;
    return createElement(el_42, createObj(ofArray([["onOpenChange", (_arg, value_1) => {
        setIsOpen(value_1.open);
    }], ["open", patternInput_1[0]], (elems_7 = [(el_4 = DialogTrigger, createElement(el_4, {
        disableButtonEnhancement: true,
        children: (children = singleton((el_2 = Button, createElement(el_2, {
            icon: (el = WarningFilled, createElement(el, {
                fontSize: 32,
                primaryFill: tokens.colorStatusDangerBackground3,
            })),
            children: "Nødvendige oppgaver",
        }))), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        })),
    })), (el_40 = DialogSurface, createElement(el_40, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        maxWidth: 700,
    }], (elems_6 = [(el_38 = DialogBody, createElement(el_38, createObj(ofArray([["style", {
        minHeight: 40 + "vh",
    }], (elems_5 = [(el_8 = DialogTitle, createElement(el_8, {
        children: (el_6 = Subtitle1, createElement(el_6, {
            children: "Læringsløp inaktivt",
        })),
    })), (el_32 = DialogContent, createElement(el_32, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_3 = [(text_1 = "Dette læringsløpet er inaktivt på grunn av manglende aktivitet over lengre tid. Nødvendige oppgaver må gjennomføres for å få full tilgang til kurs og oppgaver i læringsløpet. ", (el_10 = Caption1, createElement(el_10, {
        children: text_1,
    }))), (el_12 = Text$, createElement(el_12, {
        children: "Oppgaver som må gjøres på nytt",
    })), createElement("div", createObj(ofArray([["style", {
        marginTop: 5,
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elems_2 = toList(delay(() => map((task) => {
        let elems_1;
        const patternInput_2 = defaultArg(map_1((s) => [s, compare(s.Completed, addYears(utcNow(), -3)) >= 0], tryFind((ct) => (ct.Task.Id === task.Id), completedTasks)), [undefined, false]);
        const el_30 = Card;
        return createElement(el_30, createObj(ofArray([["size", "small"], ["appearance", "filled-alternative"], (elems_1 = toList(delay(() => {
            let el_20, el_14, el_16, el_18;
            return append(singleton_1((el_20 = CardHeader, createElement(el_20, {
                header: task.Name,
                description: (el_14 = Caption1, createElement(el_14, {
                    children: `Sist gjennomført: ${defaultArg(map_1((_arg_1) => toShortDateString(_arg_1.Completed), patternInput_2[0]), "aldri")}`,
                })),
                image: patternInput_2[1] ? ((el_16 = CheckmarkCircleFilled, createElement(el_16, {
                    primaryFill: tokens.colorStatusSuccessBackground3,
                    fontSize: 24,
                }))) : ((el_18 = TimerRegular, createElement(el_18, {
                    primaryFill: tokens.colorStatusWarningBackground3,
                    fontSize: 24,
                }))),
            }))), delay(() => {
                let el_22;
                return append(singleton_1((el_22 = Caption2, createElement(el_22, {
                    children: "Kurs med denne oppgaven",
                }))), delay(() => map((c_1) => {
                    let elems, el_26, el_24;
                    const el_28 = Link;
                    return createElement(el_28, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurs", `${c_1.Id}`]), 1)], (elems = [(el_26 = Button, createElement(el_26, {
                        iconPosition: "after",
                        icon: (el_24 = OpenRegular, createElement(el_24, {
                            fontSize: 16,
                        })),
                        appearance: "transparent",
                        children: `${c_1.Name}`,
                        size: "small",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                }, trackOverview.ReactivationCourses.filter((c) => c.Tasks.some((t) => (t.Id === task.Id))))));
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }, trackOverview.Track.ReactivationTasks))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])))), (el_36 = DialogActions, createElement(el_36, createObj(ofArray([["position", "end"], (elems_4 = [(el_34 = Button, createElement(el_34, {
        appearance: "primary",
        children: "Lukk",
        onClick: (_arg_2) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))], (elemsToUse = ((length(elems_7) <= 2) ? elems_7 : take(2, elems_7)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=TrackInactiveDialog.jsx.map
